import { WotdFormData } from "../beans/api";

export const wotdDataMapping = (data: WotdFormData, email?: string | null) => {
  let mapping = {
    email: email ? email : null,
    ...data.words,
    ...data.personalData,
  };

  return mapping;
};
